declare let require;
let context=require.context("./", true, /.tsx?$/);
let library:any={};
for(let key of context.keys())
{
    library[key.substring(0,key.lastIndexOf('.'))]=key;
}

context('./PageBuilder/Controls/Core/IPDFContainer.ts');

export=function (libraryName) {

    libraryName='./'+libraryName.substring(15);//removed /InternalShared and adding ./

    if(library[libraryName]==null)
        throw 'Library not found '+libraryName;

    return context(library[libraryName]);


}